import { g } from "analytics";
import { BACKEND_API } from "api/api";
import { reauthFromCurrentLogin } from "api/auth/reauth";
import { HorizontalButtonsSwitcher } from "components/button";
import { Select } from "components/select";
import { Slider } from "components/slider";
import Flags from "flags";
import { t } from "i18next";
import { useLoginModal } from "layout/modals/shared_modals";
import * as React from 'react';
import { Trans, useTranslation } from "react-i18next";
import { Articles, Bcn } from "support/beacon";
import { currencyLabel, currencySymbol } from "tiers/currency";
import { getPricingScheme } from "tiers/pricing";
import { BeaconLink, ChemTextHint, LicenseHint } from "tiers/promo_ui";
import { Toast } from "toast";
import { Nl } from "view/tooltips";
import { releasedAndFreeItemsCount, releasedItemsCount } from "../apparatus/spec_list";
import { BOOST_TOTAL_DIAGRAMS, ITEM_CUSTOMISATIONS, MAX_BOOST_DIAGRAM_LAYERS } from "./promo";
const TRIAL_DAYS = 7;
const SUPPORTED_CURRENCIES = [
    "gbp", "eur", "usd", "cad", "aud", "inr", "sgd", "mxn", "cop", "myr", "nzd"
];
const SCHEME = getPricingScheme(Flags.is2025PricingEnabled ? "2025" : "2022");
class BillingSwitcher extends HorizontalButtonsSwitcher {
}
export class PlansGrid extends React.Component {
    constructor(props) {
        super(props);
        this.render = () => (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "text-center mx-2 mb-3" },
                React.createElement("div", { className: "d-inline-block mb-2" },
                    React.createElement("b", null,
                        t('Currency'),
                        ": "),
                    React.createElement(Select, { id: "currency_selector", key: "currency_selector", value: this.getCurrency(), extraClass: "w-auto d-inline ml-1 mr-4", onSelectChange: (_, current) => this.setState({ currency: current }), options: SUPPORTED_CURRENCIES.map(c => ({ value: c, label: currencyLabel(c) })) })),
                React.createElement("div", { className: "d-inline-block mb-2" },
                    React.createElement("b", null,
                        t('Billing'),
                        ": "),
                    React.createElement(BillingSwitcher, { className: "d-inline-block ml-1 prominent", onSwitch: (b) => this.setState({ billing: b }), defaultValue: this.state.billing, extraClass: "narrower", options: [
                            { value: "month", icon: "", buttonLabel: "Monthly" },
                            { value: "year", icon: "", buttonLabel: "Yearly" },
                        ] }))),
            React.createElement("div", { className: "row mx-2" },
                React.createElement(PlanSelector, { currentTier: this.props.currentTier, onCheckout: p => this.props.onCheckout(p, this.getCurrency(), this.state.billing), onUpdateSchoolPlan: this.props.onUpdateSchoolPlan, onUpdateTeamPlan: this.props.onUpdateTeamPlan, signedIn: this.props.signedIn, billing: this.state.billing, currency: this.getCurrency(), closePopup: this.props.onClose }))));
        this.state = { billing: "year", showTable: true };
        let self = this;
        this.checkoutMessageHandler = (ev) => {
            // Filter any messages that are not from our API,
            // don't relate to this provider or while
            // the button is not active.
            if (ev.origin != BACKEND_API)
                return;
            let response = ev.data;
            self.onReceiveCheckoutSuccessMessage(response);
        };
        window.addEventListener("message", this.checkoutMessageHandler, true);
    }
    onReceiveCheckoutSuccessMessage(message) {
        var _a, _b;
        if (message.type == "checkout_success") {
            reauthFromCurrentLogin();
            Toast.success(t("promo.checkout_success.description"), t("promo.checkout_success.title", { tier: (_b = (_a = message.tier) === null || _a === void 0 ? void 0 : _a.capitalise()) !== null && _b !== void 0 ? _b : "" }));
            this.props.onClose();
            g("Checkout", "Success");
            if (this.props.analyticsTag) {
                g("Checkout-AnalyticsTag", this.props.analyticsTag);
            }
        }
        else if (message.type == "checkout_error") {
            Toast.error(t("promo.checkout_error.description"), t("promo.checkout_error.title"));
            g("Checkout", "Error");
        }
    }
    getCurrency() {
        var _a, _b;
        return (_b = (_a = this.state.currency) !== null && _a !== void 0 ? _a : this.props.defaultCurrency) !== null && _b !== void 0 ? _b : "usd";
    }
}
export const ExportHighQuality = () => React.createElement(Item, { icon: "image" },
    React.createElement(Trans, { i18nKey: "promo.image_quality_high" },
        React.createElement("b", null, "High"),
        " image quality"),
    React.createElement(BeaconLink, { hint: React.createElement(Nl, null, t("promo.image_res_high")), article: Articles.IMAGE_QUALITY }));
export const BoostFeatureList = ({ skipFirstLine = false }) => React.createElement(React.Fragment, null,
    !skipFirstLine && React.createElement(Item, { icon: "arrow-left" },
        React.createElement(Trans, { i18nKey: "promo.everything_included_in", values: { tier: "Start" } },
            "Everything included in ",
            React.createElement("b", null, "Start"))),
    React.createElement(Item, null,
        React.createElement(Trans, { i18nKey: "promo.n_customisations", values: { n: ITEM_CUSTOMISATIONS } },
            React.createElement("b", null, "250"),
            " more item customisations")),
    React.createElement(Item, null,
        React.createElement(Trans, { i18nKey: "promo.chem_text" },
            "Easily write formulas, units and symbols with ",
            React.createElement("b", null, "ChemText")),
        React.createElement(ChemTextHint, null)),
    React.createElement(Item, null, t("promo.style_options")),
    React.createElement(Item, null,
        React.createElement(Trans, { i18nKey: "promo.n_layers", count: MAX_BOOST_DIAGRAM_LAYERS },
            "Add up to ",
            React.createElement("b", null, "MAX_BOOST_DIAGRAM_LAYERS"),
            " liquid layers")),
    Flags.isNewTemplatesEnabled ? React.createElement(Item, null, "More diagram templates") : undefined,
    React.createElement(Item, null, t('promo.download_as', { format: "SVG" })),
    React.createElement(Item, null,
        t('promo.license'),
        " ",
        React.createElement(LicenseHint, null)),
    React.createElement(Item, null, t('No social widgets')));
function mapSliderValueToStudents(value) {
    let students = 100;
    students += Math.min(value, 10) * 25;
    value -= 10;
    if (value <= 0)
        return students;
    students += Math.min(value, 9) * 50;
    value -= 9;
    if (value <= 0)
        return students;
    students += Math.min(value, 12) * 100;
    value -= 12;
    if (value <= 0)
        return students;
    students += value * 500;
    return students;
}
// Computes the total number of diagrams for a school of given student size.
// Derived from https://docs.google.com/spreadsheets/d/1LNK9C4RMyJNWCBTed5ByMtxC3DTq-7JqrJyCvslwzLo/edit#gid=2014288311
function diagramLimit(students) {
    const diagrams = Math.log((students + 1150) / 100) / Math.LN10 * 7000 - 7500 + students * 2;
    return diagrams.round(-2);
}
const PlanSelector = (props) => {
    const [studentSliderValue, setStudentSliderValue] = React.useState(12);
    const [teamMembers, setTeamMembers] = React.useState(7);
    const students = mapSliderValueToStudents(studentSliderValue);
    const maxDiagrams = diagramLimit(students);
    const _schoolPricing = SCHEME.schoolPrice(students, props.currency, props.billing);
    const _teamPricing = SCHEME.teamPrice(teamMembers, props.currency, props.billing, "month");
    React.useEffect(() => {
        props.onUpdateSchoolPlan({ students, maxDiagrams });
    }, [students, maxDiagrams]);
    React.useEffect(() => {
        props.onUpdateTeamPlan({ teamMembers });
    }, [teamMembers]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Plan, null,
            React.createElement("div", { className: "plan-header" },
                React.createElement(PlanName, { name: "Start", icon: "vial" }),
                React.createElement(Price, { currency: props.currency, billing: props.billing }),
                React.createElement(Nl, null, t("promo.start_description"))),
            React.createElement(SignInButton, Object.assign({}, props)),
            React.createElement("ul", { className: "fa-ul feature-list" },
                React.createElement(Item, { icon: "flask" },
                    React.createElement(Trans, { i18nKey: "promo.apparatus_count", count: releasedAndFreeItemsCount },
                        React.createElement("b", null, "1"),
                        " available apparatus")),
                React.createElement(Item, { icon: "image" },
                    React.createElement(Trans, { i18nKey: "promo.image_quality_low" },
                        React.createElement("b", null, "Low"),
                        " image quality"),
                    React.createElement(BeaconLink, { hint: React.createElement(Nl, null, t('promo.image_res_low')), article: Articles.IMAGE_QUALITY })),
                React.createElement(Item, { icon: "infinity fas" }, t("promo.unlimited_image_exports")),
                React.createElement(Item, { icon: "cloud" },
                    React.createElement(Trans, { i18nKey: "promo.store_n_cloud", count: 3 },
                        "Store ",
                        React.createElement("b", null, "3"),
                        " diagrams in Cloud")),
                React.createElement("hr", null),
                React.createElement(Item, null, t('promo.download_as', { format: "JPG" })),
                React.createElement(Item, null, t('promo.download_as', { format: "PNG" })),
                React.createElement(Item, null, t('Transparent PNG')),
                React.createElement(Item, null,
                    t('promo.educational_use'),
                    React.createElement(BeaconLink, { hint: React.createElement(Nl, null, t("info.license_hint_2_nl")), article: Articles.LICENSE })))),
        React.createElement(Plan, { extraClass: "boost" },
            React.createElement("div", { className: "plan-header" },
                React.createElement(PlanName, { name: "Boost", icon: "bolt-lightning" }),
                React.createElement(Price, { price: SCHEME.price(props.currency, props.billing), currency: props.currency, billing: props.billing }),
                React.createElement(Nl, null, t("promo.boost_description", { days: TRIAL_DAYS })),
                React.createElement(DiscountTag, { billing: props.billing })),
            React.createElement(SignInButton, Object.assign({ tier: "boost" }, props)),
            React.createElement("ul", { className: "fa-ul feature-list" },
                React.createElement(Item, { icon: "flask" },
                    React.createElement(Trans, { i18nKey: "promo.apparatus_count", count: releasedItemsCount },
                        React.createElement("b", null, "1"),
                        " available apparatus")),
                React.createElement(ExportHighQuality, null),
                React.createElement(Item, { icon: "infinity fas" }, t("promo.unlimited_image_exports")),
                React.createElement(Item, { icon: "cloud" },
                    React.createElement(Trans, { i18nKey: "promo.store_n_cloud", count: BOOST_TOTAL_DIAGRAMS },
                        "Store ",
                        React.createElement("b", null, "3"),
                        " diagrams in Cloud")),
                React.createElement("hr", null),
                React.createElement(BoostFeatureList, null))),
        React.createElement(Plan, { extraClass: "team" },
            React.createElement("div", { className: "plan-header" },
                React.createElement(PlanName, { name: "Team", icon: "user-group" }),
                React.createElement(Price, { price: _teamPricing, currency: props.currency, billing: props.billing }),
                React.createElement(Nl, null, t("promo.team_description", { members: teamMembers })),
                React.createElement("div", { className: "mt-3 mx-2 mb-1" },
                    React.createElement(Slider, { key: "teamSlider", min: 3, max: 20, step: 1, initialValue: teamMembers, onChange: value => setTeamMembers(value), onEnd: (_, final) => setTeamMembers(final) })),
                React.createElement(DiscountTag, { billing: props.billing })),
            React.createElement("div", { className: "p-2" },
                React.createElement("div", { className: "d-block ui-button", onClick: () => Bcn.openTeamEnquiry(teamMembers, SCHEME.teamPrice(teamMembers, props.currency, props.billing, props.billing), props.currency, props.billing) }, t('promo.school_upgrade'))),
            React.createElement("ul", { className: "fa-ul feature-list" },
                React.createElement(Item, { icon: "flask" },
                    React.createElement(Trans, { i18nKey: "promo.apparatus_count", count: releasedItemsCount },
                        React.createElement("b", null, "1"),
                        " available apparatus")),
                React.createElement(ExportHighQuality, null),
                React.createElement(Item, { icon: "infinity fas" }, t("promo.unlimited_image_exports")),
                React.createElement(Item, { icon: "cloud" },
                    React.createElement(Trans, { i18nKey: "promo.store_n_cloud", count: BOOST_TOTAL_DIAGRAMS },
                        "Store ",
                        React.createElement("b", null, "3"),
                        " diagrams in Cloud")),
                React.createElement("hr", null),
                React.createElement(Item, { icon: "arrow-left" },
                    React.createElement(Trans, { i18nKey: "promo.everything_included_in", values: { tier: "Boost" } },
                        "Everything included in ",
                        React.createElement("b", null, "Boost"),
                        " ")),
                React.createElement(Item, null,
                    React.createElement(Trans, { i18nKey: "promo.access_members", count: teamMembers },
                        "Access for ",
                        React.createElement("b", null, teamMembers),
                        " members")),
                React.createElement(Item, null, t("promo.school_email_sign_in")),
                React.createElement(Item, null, t("promo.team_individual_email")))),
        React.createElement(Plan, { extraClass: "school" },
            React.createElement("div", { className: "plan-header" },
                React.createElement(PlanName, { name: t("School"), icon: "landmark" }),
                React.createElement(Price, { price: _schoolPricing, currency: props.currency, billing: props.billing }),
                React.createElement(Nl, null, t("promo.school_description", { students })),
                React.createElement("div", { className: "mt-3 mx-2 mb-1" },
                    React.createElement(Slider, { key: "studentSlider", min: 0, max: 32, step: 1, initialValue: studentSliderValue, onChange: value => setStudentSliderValue(value), onEnd: (_, final) => setStudentSliderValue(final) })),
                React.createElement(DiscountTag, { billing: props.billing })),
            React.createElement("div", { className: "p-2" },
                React.createElement("div", { className: "d-block ui-button", onClick: () => Bcn.openSchoolEnquiry(students, SCHEME.schoolPrice(students, props.currency, props.billing, props.billing), props.currency, props.billing) }, t('promo.school_upgrade'))),
            React.createElement("ul", { className: "fa-ul feature-list" },
                React.createElement(Item, { icon: "flask" },
                    React.createElement(Trans, { i18nKey: "promo.apparatus_count", count: releasedItemsCount },
                        React.createElement("b", null, "1"),
                        " available apparatus")),
                React.createElement(ExportHighQuality, null),
                React.createElement(Item, { icon: "infinity fas" }, t("promo.unlimited_image_exports")),
                React.createElement(Item, { icon: "cloud" },
                    React.createElement(Trans, { i18nKey: "promo.store_n_cloud_inf" },
                        "Store ",
                        React.createElement("b", null,
                            React.createElement("i", { className: "fas fa-infinity mx-1" })),
                        " diagrams in Cloud")),
                React.createElement("hr", null),
                React.createElement(Item, { icon: "arrow-left" },
                    React.createElement(Trans, { i18nKey: "promo.everything_included_in", values: { tier: "Boost" } },
                        "Everything included in ",
                        React.createElement("b", null, "Boost"),
                        " ")),
                React.createElement(Item, null,
                    React.createElement(Trans, { i18nKey: "promo.access_students", count: students },
                        "Access for ",
                        React.createElement("b", null, students),
                        " students")),
                React.createElement(Item, null, t("promo.access_teachers")),
                React.createElement(Item, null, t("promo.school_email_sign_in"))))));
};
const DiscountTag = (props) => {
    const { t } = useTranslation();
    return props.billing == "year"
        ? React.createElement("span", { className: "discount-tag" }, t('promo.discount', { count: 20 }))
        : null;
};
const SignInButton = (props) => {
    if (!props.signedIn) {
        // If the user is not signed in, they are automatically on the basic tier.
        if (!props.tier)
            return React.createElement(YourCurrentPlan, null);
        return React.createElement(SignInToUpgrade, { closePopup: props.closePopup });
    }
    if ((!props.tier && !props.currentTier) || props.tier === props.currentTier) {
        return React.createElement(YourCurrentPlan, null);
    }
    else if (props.tier === "boost" && !props.currentTier) {
        return React.createElement(UpgradeButton, { tier: "boost", onClick: () => props.onCheckout("boost") });
    }
    else if (props.tier === "plus" && !props.currentTier) {
        return React.createElement(UpgradeButton, { tier: "plus", onClick: () => props.onCheckout("plus") });
    }
    else {
        return React.createElement("div", { className: "invisible" },
            React.createElement(YourCurrentPlan, null));
    }
};
const YourCurrentPlan = () => {
    const { t } = useTranslation();
    return React.createElement("div", { className: "py-2 px-3 text-center" },
        React.createElement("div", { className: "d-block ui-button-inactive" }, t('promo.your_current_plan')));
};
const SignInToUpgrade = ({ closePopup }) => {
    const { openLogin } = useLoginModal();
    const { t } = useTranslation();
    function onLoginSuccess(tier) {
        if (tier) {
            closePopup();
        }
    }
    return React.createElement("div", { className: "mt-auto py-2 px-3" },
        React.createElement("div", { className: "d-block ui-button", onClick: () => openLogin(onLoginSuccess) }, t('promo.sign_in')));
};
const UPGRADE_BUTTON_TIMEOUT_MS = 4000;
/**
 * Upgrade button. Is unclickable for few seconds after being clicked,
 * showing a spinner.
 */
const UpgradeButton = (props) => {
    const [pending, setPending] = React.useState(false);
    function onClick() {
        if (pending)
            return;
        props.onClick();
        setPending(true);
        setTimeout(() => { setPending(false); }, UPGRADE_BUTTON_TIMEOUT_MS);
    }
    return React.createElement("div", { className: "mt-auto p-2" },
        React.createElement("div", { className: "d-block ui-button", onClick: onClick },
            "\u00A0",
            pending ?
                React.createElement("i", { className: "fas fa-lg fa-circle-notch fa-spin" }) :
                t('promo.upgrade_to', { tier: props.tier.capitalise() }),
            "\u00A0"));
};
const _Plan = (props) => (React.createElement("div", { className: "col-12 col-sm-6 col-lg-3 mb-3 px-1" },
    React.createElement("div", { className: `plan d-flex flex-column ${props.extraClass}` }, props.children)));
const Plan = React.memo(_Plan);
const Price = (props) => {
    var _a;
    return (React.createElement("span", { className: "price" },
        props.from ? React.createElement("sub", null, "from") : null,
        React.createElement("sup", null, currencySymbol(props.currency)),
        ((_a = props.price) !== null && _a !== void 0 ? _a : 0).toLocaleFixed(2),
        React.createElement("sub", null, "/mo")));
};
const PlanName = (props) => React.createElement("h3", null,
    React.createElement("i", { className: `fas fa-${props.icon} mr-2` }),
    props.name);
export const Disclaimer = () => {
    const { t } = useTranslation();
    return React.createElement("p", { className: "text-muted text-center" },
        React.createElement("i", null,
            React.createElement(Trans, { i18nKey: "promo.footer_1", t: t },
                "Cancel anytime. Learn more about ",
                React.createElement("a", { "data-beacon-article-modal": Articles.SUBSCRIPTIONS, href: "#" }, "subscriptions")),
            React.createElement("br", null),
            React.createElement(Trans, { i18nKey: "promo.footer_2", t: t },
                "By upgrading, you agree to our ",
                React.createElement("a", { href: "http://help.chemix.org/tos", target: "_blank" }, "Terms and Conditions."))));
};
export const Item = (props) => (React.createElement("li", null,
    React.createElement("span", { className: "fa-li" },
        React.createElement("i", { className: `fa fa-${props.icon || "check"}` })),
    props.children));
